<template>
  <div>
    <div v-if="currentServiceProducts.length === 0" class="p1">Loading...</div>
    <ServicePackage v-if="serviceDetails && currentServiceProducts.length" :selected="serviceDetails" :packages="currentServiceProducts" />
  </div>
</template>
<script>
import ServiceItemMixin from './service-item-mixins'
import ServicePackage from './ServicePackage'
import { mapActions, mapState } from 'vuex'

export default {
  mixins: [ServiceItemMixin],
  components: {
    ServicePackage
  },
  methods: {},
  mounted () {
    this.fetchServiceData()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Services/ServiceDetails.vue